<template>
  <span>
    <v-row dense justify="center">
      <v-col cols="12" md="auto" class="flex-md-grow-1">
        <v-card class="my-1 elevation-0" style="height: 98.5%;">
          <v-card-text>
            <kpis-by-municipio-data-table
              :dadosKpisByMunicipio="dadosKpisTotalizadosPorMunicipio"
              :labelKpis="labelKpis"
              :is-loading="isLoadingDados"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="auto" class="flex-md-grow-1">
        <v-card class="my-1 elevation-0">
          <v-card-text>
            <kpis-by-municipio-map
              :dadosKpisByMunicipio="dadosKpisTotalizadosPorMunicipio"
              :labelKpis="labelKpis"
              :listaKpisPercentual="['percentual_negadas']"
              :is-loading="isLoadingDados"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      dense
      justify="center"
      v-for="chart in dataCharts"
      :key="chart.title"
    >
      <v-col cols="12" :key="chart.title">
        <v-card-charts-dashboard
          :title="chart.title"
          :chart-ref="chart.key"
          :tooltip-text="chart.tooltipText"
          :options="chart.options"
          :deep-copy-on-update="false"
          :is-loading="!!loadingPorChave[chart.key]"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script>
import Highcharts from "highcharts";
import HighchartsNoData from "highcharts/modules/no-data-to-display";
HighchartsNoData(Highcharts);
import exporting from "highcharts/modules/exporting";
import exportData from "highcharts/modules/export-data";
import DashboardRessarcimentoDanosEletricosService from "@/services/DashboardRessarcimentoDanosEletricosService";
import KpisByMunicipioMap from "./KpisByMunicipioMap.vue";
import KpisByMunicipioDataTable from "./KpisByMunicipioDataTable.vue";
import VCardChartsDashboard from "@/components/base/VCardChartsDashboard.vue";

exporting(Highcharts);
exportData(Highcharts);

export default {
  name: "DashboardRessarcimentoDanosEletricosVisaoMunicipios",
  components: {
    KpisByMunicipioMap,
    KpisByMunicipioDataTable,
    VCardChartsDashboard,
  },
  props: {
    competenciaDe: {
      type: String,
      required: true,
    },
    competenciaAte: {
      type: String,
      required: true,
    },
    activatedTab: {
      type: Number,
      required: true,
    },
    regionalSelecionada: {
      type: Number,
      default: 0,
    },
    visaoGraficos: {
      type: String,
      default: "mensal",
    },
    quantidadeMunicipios: {
      type: Number,
      default: 30,
    },
  },
  data() {
    return {
      dadosPercentualSolicitacoesRessarcimentoNegadas: {},
      dadosQtdeSolicitacoesRessarcimentoPorDanosEletricos: {},
      dadosQtdeSolicitacoesIndeferidasPorDanosEletricos: {},
      dadosValorTotalPendenteDeferido: {},
      dadosValorTotalPagoPorRessarcimento: {},
      dadosKpisTotalizadosPorMunicipio: {},
      labelKpis: {
        percentual_negadas:
          "Percentual de solicitações de ressarcimento negadas",
        qntd_ressarcimento_danos_eletricos:
          "Quantidade de solicitações de ressarcimento por danos elétricos",
        qntd_indeferidas_danos_eletricos:
          "Quantidade de solicitações indeferidas por danos elétricos",
        solicitacoes_deferidas: "Valor Total Pendente Deferido (R$)",
        valor_pago_ressarcimento_danos_eletricos:
          "Valor Total Pago por Ressarcimento (R$)",
      },
      debounceTimer: null,
      isLoadingDados: false,
      loadingPorChave: {
        percentualNegadas: false,
        quantidadeRessarcimento: false,
        quantidadeIndeferidas: false,
        valorPendenteDeferido: false,
        valorPagoRessarcimento: false,
      },
      dataChartsConfig: [
        {
          key: "percentualNegadas",
          title: "Percentual de solicitações de ressarcimento negadas (%)",
          tooltipKey: "percentualNegadas",
          chartOptionsKey:
            "chartOptionsPercentualSolicitacoesRessarcimentoNegadas",
        },
        {
          key: "quantidadeRessarcimento",
          title:
            "Quantidade de solicitações de ressarcimento por danos elétricos",
          tooltipKey: "quantidadeRessarcimento",
          chartOptionsKey:
            "chartOptionsQtdeSolicitacoesRessarcimentoPorDanosEletricos",
        },
        {
          key: "quantidadeIndeferidas",
          title: "Quantidade de solicitações indeferidas por danos elétricos",
          tooltipKey: "quantidadeIndeferidas",
          chartOptionsKey:
            "chartOptionsQtdeSolicitacoesIndeferidasPorDanosEletricos",
        },
        {
          key: "valorPendenteDeferido",
          title: "Valor Total Pendente Deferido (R$)",
          tooltipKey: "valorPendenteDeferido",
          chartOptionsKey: "chartOptionsValorTotalPendenteDeferido",
        },
        {
          key: "valorPagoRessarcimento",
          title: "Valor Total Pago por Ressarcimento (R$)",
          tooltipKey: "valorPagoRessarcimento",
          chartOptionsKey: "chartOptionsValorTotalPagoPorRessarcimento",
        },
      ],
    };
  },
  computed: {
    dataCharts() {
      return this.dataChartsConfig.map((config) => ({
        key: config.key,
        title: config.title,
        options: this[config.chartOptionsKey],
      }));
    },
    chartOptionsPercentualSolicitacoesRessarcimentoNegadas() {
      return this.criarGrafico({
        dados: this.dadosPercentualSolicitacoesRessarcimentoNegadas,
        campo: "percentual_negadas",
        nomeSerie: "% Negadas",
        tituloY: "Percentual (%)",
        formato: "{point.y:.2f}%",
        valorReferencia: 30,
      });
    },
    chartOptionsQtdeSolicitacoesRessarcimentoPorDanosEletricos() {
      return this.criarGrafico({
        dados: this.dadosQtdeSolicitacoesRessarcimentoPorDanosEletricos,
        campo: "qntd_ressarcimento_danos_eletricos",
        nomeSerie: "Solicitações",
        tituloY: "Quantidade",
        formato: "{point.y}",
      });
    },
    chartOptionsQtdeSolicitacoesIndeferidasPorDanosEletricos() {
      return this.criarGrafico({
        dados: this.dadosQtdeSolicitacoesIndeferidasPorDanosEletricos,
        campo: "qntd_indeferidas_danos_eletricos",
        nomeSerie: "Indeferidas",
        tituloY: "Quantidade",
        formato: "{point.y}",
      });
    },
    chartOptionsValorTotalPendenteDeferido() {
      return this.criarGrafico({
        dados: this.dadosValorTotalPendenteDeferido,
        campo: "solicitacoes_deferidas",
        nomeSerie: "Valor Pendente",
        tituloY: "Valor (R$)",
        formato: "R$ {point.y:,.2f}",
      });
    },
    chartOptionsValorTotalPagoPorRessarcimento() {
      return this.criarGrafico({
        dados: this.dadosValorTotalPagoPorRessarcimento,
        campo: "valor_pago_ressarcimento_danos_eletricos",
        nomeSerie: "Valor Pago",
        tituloY: "Valor (R$)",
        formato: "R$ {point.y:,.2f}",
      });
    },
  },
  watch: {
    competenciaAte() {
      this.getDadosComDebounce();
    },
    competenciaDe() {
      this.getDadosComDebounce();
    },
    regionalSelecionada() {
      this.getDadosComDebounce();
    },
    quantidadeMunicipios() {
      this.getDadosComDebounce();
    },
    activatedTab(newVal) {
      if (newVal === 1) {
        this.getDados();
      }
    },
  },
  mounted() {
    this.getDados();
  },
  beforeDestroy() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
    this.limparDados();
  },
  methods: {
    criarGrafico({
      dados,
      campo,
      nomeSerie,
      tituloY,
      formato,
      cor,
      valorReferencia = null,
    }) {
      const dadosOrdenados = Object.entries(dados)
        .map(([municipio, obj]) => ({
          municipio,
          valor: obj?.[campo] || 0,
        }))
        .sort((a, b) => b.valor - a.valor);

      const dadosFinais =
        this.quantidadeMunicipios > 0
          ? dadosOrdenados.slice(0, this.quantidadeMunicipios)
          : dadosOrdenados;

      const municipios = dadosFinais.map((d) => d.municipio);
      const valores = dadosFinais.map((d) => d.valor);

      return {
        chart: {
          type: "column",
          zoomType: "x",
          animation: {
            duration: 800,
          },
        },
        title: { text: null },
        xAxis: {
          categories: municipios,
        },
        yAxis: {
          title: { text: tituloY },
          plotLines: valorReferencia
            ? [
                {
                  value: valorReferencia,
                  color: this.$vuetify.theme.themes.light.success,
                  width: 2,
                  zIndex: 5,
                  label: {
                    text: `Limite de Referência: ${valorReferencia}%`,
                    align: "right",
                    verticalAlign: "top",
                    style: {
                      color: this.$vuetify.theme.themes.light.success,
                      fontWeight: "bold",
                      fontSize: "14px",
                    },
                  },
                },
              ]
            : [],
        },
        plotOptions: {
          series: {
            animation: {
              duration: 800,
            },
          },
        },
        series: [
          {
            name: nomeSerie,
            data: valores,
            color: cor,
          },
        ],
        tooltip: {
          pointFormat: formato,
        },
        lang: {
          noData: "Sem dados para exibição",
        },
        credits: { enabled: false },
        exporting: {
          enabled: true,
          buttons: {
            contextButton: {
              menuItems: [
                "viewFullscreen",
                "separator",
                "downloadPNG",
                "downloadJPEG",
                "downloadPDF",
                "downloadSVG",
                "separator",
                "downloadCSV",
                "downloadXLS",
              ],
            },
          },
        },
      };
    },
    setLoadingPorChave(value) {
      this.dataChartsConfig.forEach((config) => {
        this.loadingPorChave[config.key] = value;
      });
    },
    async getDados() {
      if (this.isLoadingDados) return;

      this.isLoadingDados = true;
      this.setLoadingPorChave(true);
      this.$emit("updateLoadingDados", true);

      try {
        await Promise.all([
          this.getDadosPercentualSolicitacoesRessarcimentoNegadas(),
          this.getDadosQtdeSolicitacoesRessarcimentoPorDanosEletricos(),
          this.getDadosQtdeSolicitacoesIndeferidasPorDanosEletricos(),
          this.getDadosValorTotalPendenteDeferido(),
          this.getDadosValorTotalPagoPorRessarcimento(),
          this.getDadosKpisTotalizadosPorMunicipio(),
        ]);
      } catch (err) {
        console.error(err);
        this.$toast.error("Erro ao recuperar dados", "", {
          position: "topRight",
        });
      } finally {
        this.isLoadingDados = false;
        this.setLoadingPorChave(false);
        this.$emit("updateLoadingDados", false);
      }
    },
    getDadosComDebounce() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      this.debounceTimer = setTimeout(() => {
        this.getDados();
      }, 500);
    },
    getDadosKpisTotalizadosPorMunicipio() {
      return DashboardRessarcimentoDanosEletricosService.getKpisTotalizadosPorMunicipio(
        this.competenciaDe,
        this.competenciaAte,
        this.regionalSelecionada,
      )
        .then((res) => {
          this.dadosKpisTotalizadosPorMunicipio = res;
        })
        .catch((err) => {
          throw err;
        });
    },
    getDadosPercentualSolicitacoesRessarcimentoNegadas() {
      return DashboardRessarcimentoDanosEletricosService.getDadosTotaisRessarcimentoDanosEletricosVisaoMunicipios(
        this.competenciaDe,
        this.competenciaAte,
        this.regionalSelecionada,
      )
        .then((res) => {
          this.dadosPercentualSolicitacoesRessarcimentoNegadas = res;
        })
        .catch((err) => {
          throw err;
        });
    },
    getDadosQtdeSolicitacoesRessarcimentoPorDanosEletricos() {
      return DashboardRessarcimentoDanosEletricosService.getDadosTotaisRessarcimentoDanosEletricosVisaoMunicipios(
        this.competenciaDe,
        this.competenciaAte,
        this.regionalSelecionada,
      )
        .then((res) => {
          this.dadosQtdeSolicitacoesRessarcimentoPorDanosEletricos = res;
        })
        .catch((err) => {
          throw err;
        });
    },
    getDadosQtdeSolicitacoesIndeferidasPorDanosEletricos() {
      return DashboardRessarcimentoDanosEletricosService.getDadosTotaisRessarcimentoDanosEletricosVisaoMunicipios(
        this.competenciaDe,
        this.competenciaAte,
        this.regionalSelecionada,
      )
        .then((res) => {
          this.dadosQtdeSolicitacoesIndeferidasPorDanosEletricos = res;
        })
        .catch((err) => {
          throw err;
        });
    },
    getDadosValorTotalPendenteDeferido() {
      return DashboardRessarcimentoDanosEletricosService.getValorPendenteSolicitacoesDeferidasVisaoMunicipios(
        this.competenciaDe,
        this.competenciaAte,
        this.regionalSelecionada,
      )
        .then((res) => {
          this.dadosValorTotalPendenteDeferido = res;
        })
        .catch((err) => {
          throw err;
        });
    },
    getDadosValorTotalPagoPorRessarcimento() {
      return DashboardRessarcimentoDanosEletricosService.getValorPagoRessarcimentoDanosEletricosVisaoMunicipios(
        this.competenciaDe,
        this.competenciaAte,
        this.regionalSelecionada,
      )
        .then((res) => {
          this.dadosValorTotalPagoPorRessarcimento = res;
        })
        .catch((err) => {
          throw err;
        });
    },
    limparDados() {
      this.dadosPercentualSolicitacoesRessarcimentoNegadas = {};
      this.dadosQtdeSolicitacoesRessarcimentoPorDanosEletricos = {};
      this.dadosQtdeSolicitacoesIndeferidasPorDanosEletricos = {};
      this.dadosValorTotalPendenteDeferido = {};
      this.dadosValorTotalPagoPorRessarcimento = {};
      this.dadosKpisTotalizadosPorMunicipio = {};
    },
  },
};
</script>

<style></style>
